import { toHttps } from './util'

function filterSinger(singers) {
  if (!Array.isArray(singers) || !singers.length) {
    return ''
  }
  let arr = []
  singers.forEach((item) => {
    arr.push(item.name)
  })
  return arr.join('/')
}

export class Song {
  constructor({ id, name, singer, album, image, duration, url, hasLyric, isLocation }) {
    this.id = id
    this.name = name
    this.singer = singer
    this.album = album
    this.image = image
    this.duration = duration
    this.url = url
    this.hasLyric = hasLyric
    this.isLocation = isLocation
  }
}

export function createSong(music) {
  return new Song({
    id: music.nameId,
    name: music.name,
    singer: music.singer,
    album: music.album,
    image: /^https?:\/\//.test(music.imgUrl)
      ? music.imgUrl
      : `https://www.hifini.com/${music.imgUrl}`,
    duration: music.duration,
    url: music.downloadUrl,
    hasLyric: music['hasLyric'],
    isLocation: music['isLocation']
  })
}

// 获取歌曲时长
export function getMusicDuration(url) {
  return new Promise((resolve, reject) => {
    let audio = new Audio()
    audio.src = url
    audio.addEventListener('loadedmetadata', () => {
      resolve(audio.duration)
    })
  })
}

// 歌曲数据格式化
export function formatSongs(list) {
  const Songs = []
  list.forEach((item) => {
    const musicData = item
    if (musicData.nameId) {
      Songs.push(createSong(musicData))
    }
  })
  return Songs
}

export function decrypt(str) {
  var sb = ''
  for (var i = 0; i < str.length; i++) {
    var c = str.charAt(i)
    c = String.fromCharCode(c.charCodeAt(0) - 3)
    sb += c
  }
  return sb
}
